import HomeCounter from "../Home/HomeCounter";
import ServiceDetailSlide from "../ServiceDetail/ServiceDetailSlide";
import ProdunitHead from "./ProdunitHead";
import ProdunitModular from "./ProdunitModular";
import AboutVision from "../About/AboutVision";
import ServiceDetailProcess from "../TurnkeySolution/ServiceDetailProcess";
import ProdunitQuote from "./ProdunitQuote";
import ProdunitVideo from "./ProdunitVideo";
import ProdunitShowroom from "./ProdunitShowroom";

export default function ProductionUnit() {
    const imgSlide = [
      { 
        title: '',
        name: 'Upholstery Work',
        para: 'upholstery craftsmanship for comfort and elegance.',
        link: '/contact',
        linktext: 'Contact Us for Info',
        imageA: '../image/production-split-1.webp',
        imageB: '../image/production-split-1b.webp',
      },

      { 
        title: '',
        name: 'Stones',
        para: 'Elegant stone finishes that redefine timeless luxury.',
        link: '/contact',
        linktext: 'Contact Us for Info',
        imageA: '../image/production-split-2.webp',
        imageB: '../image/production-split-2b.webp',
      },

      { 
        title: '',
        name: 'Paint Booth',
        para: 'State-of-the-art paint booth ensuring flawless, high-quality coatings.',
        link: '/contact',
        linktext: 'Contact Us for Info',
        imageA: '../image/production-split-3.webp',
        imageB: '../image/production-split-3b.webp',
      },

      { 
        title: '',
        name: 'Metal Fabrication',
        para: 'Precision metal fabrication for strength and style.',
        link: '/contact',
        linktext: 'Contact Us for Info',
        imageA: '../image/production-split-4.webp',
        imageB: '../image/production-split-4b.webp',
      },

      { 
        title: '',
        name: 'Millwork',
        para: 'Detailed millwork crafted for timeless sophistication.',
        link: '/contact',
        linktext: 'Contact Us for Info',
        imageA: '../image/production-split-5.webp',
        imageB: '../image/production-split-5b.webp',
      },
    ]


    const methodData = {
    heading: "Modular Mastery",
    processSteps: [
      {
        left: {
          count: "01",
          title: "The Pressing Process",
          desc: "Panels are pressed with precision to ensure strength, stability, and a flawless foundation.",
          img: "../image/production-process-1.webp",
        },
        right: {
          count: "02",
          title: "Precision Cutting Process",
          desc: "Advanced cutting tools shape every panel to exact dimensions for perfect alignment.",
          img: "../image/production-process-2.webp",
        },
      },

      {
        left: {
          count: "03",
          title: "CNC Machining Excellence",
          desc: "Automated CNC systems craft intricate designs with unmatched accuracy and consistency.",
          img: "../image/production-process-3.webp",
        },
        right: {
          count: "04",
          title: "Edge Banding Perfection",
          desc: "Smooth, seamless edges are applied for a refined look and durable finish.",
          img: "../image/production-process-4.webp",
        },
      },

      {
        left: {
          count: "05",
          title: "Expert Assembling Process",
          desc: "Every component is assembled with care to create structures that are sturdy and precise.",
          img: "../image/production-process-5.webp",
        },
        right: {
          count: "06",
          title: "Final Quality Inspection",
          desc: "Each product undergoes rigorous checks to meet our uncompromising quality standards.",
          img: "../image/production-process-6.webp",
        },
      },

      {
        left: {
          count: "07",
          title: "Safe & Secure Dispatch",
          desc: "Finished goods are carefully packed and dispatched to ensure safe, timely delivery.",
          img: "../image/production-process-7.webp",
        },
        right: {
          count: "08",
          title: "Site Restoration & Finishing",
          desc: "Our team restores and refines the site to deliver a clean, ready-to-use space.",
          img: "../image/production-process-8.webp",
        },
      },
    ],
  };


  const visionData = {
      leftImage: "../image/prodvision-1.webp",
      rightImage: "../image/prodvision-2.webp",
      heading: "Build with Precision",
      text: "Shape your ideas into reality through expertly engineered interiors designed for your needs. At Saysha Interiors, we design, fabricate, and deliver solutions, elevating your vision into refined and functional environments.",
  };

  return (
    <>
    <ProdunitHead />
    <ProdunitQuote/>
    <ProdunitVideo/>
    <HomeCounter/>
    <ProdunitShowroom/>
    <ServiceDetailProcess methodData={methodData}/>
    {/* <section className="turnkey-stylearea"> <ProdunitModular/> </section> */}
    <ProdunitModular/>
    <ServiceDetailSlide imgSlide={imgSlide}/>
    <section className="prodvision"><AboutVision visionData={visionData}/></section>
    </>
  )
}
